<!--
 * @Description: 新增/编辑form基础信息表单组件
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="page-wrap page-update-wrap">
    <jw-space direction="vertical">
      <div class="form-panel">
        <jw-space direction="vertical">
          <jw-affix offset-top="1" class="arco-affix-content">
            <jw-card class="form-title-card">
              <div class="form-title-content">
                <span class="edit-title">
                  {{ getTitle }}
                </span>
              </div>
              <jw-space>
                <!-- 提交 -->
                <jw-button size="small" type="primary" v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']" :loading="loading" @click="submit">
                  <template #icon v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.icon && (data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.showType == 0 || data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.showType == 1)">
                    <component :is="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.icon" />
                  </template>
                  <template v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.showType == 0 || data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.showType == 2">
                    {{ data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.title }}
                  </template>
                  <template v-else>
                    {{ data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':commit']?.title }}
                  </template>
                </jw-button>
                <!-- 提交并发起审批 -->
                <jw-button size="small" v-if="showApproveBtn && statusOrigin !== 2" type="primary" :loading="loading" @click="submit('approve')">
                  <jw-space>
                    <span>保存并发起审批</span>
                    <jw-tooltip :popup-translate="[-100, 10]">
                      <icon-question-circle-fill />
                      <template #content>
                        <p>1.保存提交并发起审批时，会直接发起审批</p>
                        <p>2.选择保存时，不会发起审批，可在完善信息后，再发起审批</p>
                      </template>
                    </jw-tooltip>
                  </jw-space>
                </jw-button>
                <!--提交并按明细拆分(销售订单的)  -->
                <template v-if="data.entity == 10 && data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']">
                  <jw-button size="small" type="primary" v-if="data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']" :loading="loading" @click="splitOrderSubmit">
                    <template #icon v-if="data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit'].icon && (data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.showType == 0 || data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.showType == 1)">
                      <component :is="data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.icon" />
                    </template>
                    <template v-if="data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.showType == 0 || data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.showType == 2">
                      {{ data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.title }}
                    </template>
                    <template v-else>
                      {{ data.buttonsObj?.[`${data.operationObj[data.entity]}` + ':commitAndSplit']?.title }}
                    </template>
                  </jw-button>
                  <jw-tooltip position="lt">
                    <template #content> {{ $t('tips.saveOrder') }} </template>
                    <icon-question-circle size="20" />
                  </jw-tooltip>
                </template>
                <!-- 取消 -->
                <jw-button size="small" type="outline" v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']" @click="emits('cb', 'cancel')">
                  <template #icon v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.icon && (data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.showType == 0 || data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.showType == 1)">
                    <component :is="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.icon" />
                  </template>
                  <template v-if="data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.showType == 0 || data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.showType == 2">
                    {{ data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.title }}
                  </template>
                  <template v-else>
                    {{ data.buttonsObj?.[`${data.entity >= 200 ? data.entity : data.operationObj[data.entity]}` + ':cancel']?.title }}
                  </template>
                </jw-button>
              </jw-space>
            </jw-card>
          </jw-affix>
          <jw-card class="content">
            <xl-tab @detailCb="getViewId" v-show="data.type === 30 && !grayList?.['Layout:viewInit']" :entity="data.entity" fromPage="detail"></xl-tab>
            <jw-spin
              :loading="loading"
              :tip="data.loadingTips"
              :class="{
                'spin-loading': loading,
                'spin-init-loading': !data.saveStatus
              }"
            >
              <template v-if="data.form.formData?.length > 0">
                <jw-form :model="data.form" label-align="left" class="form-min-width" ref="editAddForm" @submit="handleSubmit" scroll-to-first-error>
                  <jw-row :gutter="50">
                    <template v-for="(item, parentIndex) in data.form.formData" :key="item.id">
                      <jw-card :bordered="false" class="detail-info" v-if="item?.modules?.length > 0 && validateConditionsDisplay(item)?.length > 0">
                        <template #title v-if="isShowGroupName(item?.modules)">
                          <p class="card-title">
                            {{ item?.label || '分组' }}
                            <jw-tooltip v-if="item?.toast">
                              <icon-question-circle size="18" class="card-tooltip" />
                              <!-- 这是提示文本  -->
                              <template #content> {{ item.toast }} </template>
                            </jw-tooltip>
                          </p>
                        </template>
                        <template v-for="(modulesItem, index) in item?.modules" :key="modulesItem.id">
                          <template v-if="((modulesItem?.conditionsDisplay == 1 && modulesItem.display == 2) || modulesItem.display == 1) && (modulesItem.type == '20' ? getFollowIsHide(modulesItem) : true)">
                            <!--  0是1/2行展示，1是整行 2是1/3  3是2/3行展示 -->
                            <jw-col :span="modulesItem.type == '30' || modulesItem.type == '35' || (modulesItem.type == '20' && (data.displayOneLineFields.includes(modulesItem?.setting?.fieldType) || modulesItem.displayOneLine == 1)) ? 24 : modulesItem.type == '20' && modulesItem.displayOneLine == 0 ? 12 : modulesItem.type == '20' && modulesItem.displayOneLine == 3 ? 16 : modulesItem.type == '20' && modulesItem.displayOneLine == 2 ? 8 : 12">
                              <!-- 字段 -->
                              <template v-if="modulesItem.type == '20'">
                                <!-- 类名`system-form-item-${modulesItem?.setting?.id}`勿删：此处为兼容下拉等弹窗popup-container的定位问题 -->
                                <jw-form-item
                                  asterisk-position="end"
                                  :field="`formData.${parentIndex}.modules.${index}.fieldValue`"
                                  :class="['system-form-item', `system-form-item-${modulesItem?.setting?.id}`, modulesItem?.setting?.fieldType === 12 ? 'relevancy-input' : '']"
                                  :rules="modulesItem.value === 'mobile' && data.entity == 2 ? mobileRules(modulesItem) : rules(modulesItem)"
                                  :validate-trigger="['blur', 'input', 'change']"
                                  :label-col-style="{
                                    width: labelWidth(modulesItem)
                                  }"
                                  label-col-flex="auto"
                                  class="form-label-text"
                                >
                                  <template #label>
                                    <xl-label-text :value="modulesItem.label" :row="1" />
                                    <jw-tooltip v-if="modulesItem?.toast">
                                      <icon-question-circle size="18" />
                                      <!-- 这是提示文本  -->
                                      <template #content>
                                        {{ modulesItem.toast }}
                                      </template>
                                    </jw-tooltip>
                                  </template>
                                  <!-- 线索和线索池对象公司名称判重 -->
                                  <template v-if="(data.entity == 1 || data.entity == 101) && modulesItem.value === 'companyName'">
                                    <jw-input v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-fields" @press-enter="companyInput(modulesItem)" @blur="companyInput(modulesItem)" />
                                    <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                                  </template>
                                  <!-- 客户对象特殊处理 -->
                                  <!-- 客户名称 -->
                                  <template v-else-if="data.entity == 2 && modulesItem.value === 'customerName'">
                                    <div class="customer-name-list">
                                      <div class="customer-name-item">
                                        <jw-input v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-fields" @input="customerInput(modulesItem)">
                                          <template #suffix>
                                            <jw-tooltip v-if="data.qccId" :content="$t('查看工商信息')" position="br" mini>
                                              <span @click.stop="busineShow" style="display: flex; align-items: center">
                                                <qf-icon-business class="icon-qcc" width="20px" height="20px" color="rgb(var(--primary-6))" />
                                              </span>
                                            </jw-tooltip>
                                            <qf-icon-business class="icon-qcc disabled" v-else width="20px" height="20px" color="#C9CDD4" />
                                          </template>
                                        </jw-input>
                                      </div>
                                      <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                                    </div>
                                  </template>
                                  <!-- 关联工商信息 -->
                                  <template v-else-if="data.entity == 2 && modulesItem.value === 'qccId'">
                                    <div style="display: flex; flex-direction: column">
                                      <jw-button @click="correlation" :disabled="modulesItem.businessData == '0' || data.disabledAll" size="small" type="primary">{{ $t('关联工商信息') }}</jw-button>
                                      <span v-if="!data.qccId && (modulesItem.isRequired == 1 || modulesItem?.conditionsIsRequired == 1)" style="color: rgb(var(--danger-6)); font-size: 12px">{{ $t('tips.customerIsRequired') }}</span>
                                    </div>
                                  </template>
                                  <!-- 商机对象特殊处理 -->
                                  <!-- 商机名称校验-->
                                  <template v-else-if="data.entity == 3 && modulesItem.value === 'opportunityName'">
                                    <jw-input v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :disabled="modulesItem.businessData == '0' || data.disabledAll" class="system-form-item-value" @press-enter="changeOpportunityName(modulesItem)" @blur="changeOpportunityName(modulesItem)" />
                                    <xl-check-name v-show="modulesItem.fieldValue" ref="checkName" />
                                  </template>
                                  <template v-else-if="data.entity == 3 && modulesItem.value === 'association_b6DERm'">
                                    <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll ? true : false" @change="fundChange" />
                                  </template>
                                  <!-- 合同/订单中的报价单 -->
                                  <template v-else-if="(data.entity == 8 || data.entity == 10) && modulesItem.value === 'priceSheetId'">
                                    <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll ? true : false" @change="priceChange(6)" />
                                  </template>

                                  <!-- 订单中的合同 -->
                                  <template v-else-if="data.entity == 10 && modulesItem.value === 'contractId'">
                                    <xl-association :modules-item="modulesItem" :placeholder="modulesItem?.placeholder || ''" :form-data="data.form.formData" v-model="modulesItem.fieldValue" :disabled="modulesItem.businessData == '0' || data.disabledAll ? true : false" @change="contractChange(8)" />
                                  </template>
                                  <template v-else>
                                    <!-- {{  modulesItem?.setting?.business?.fieldType }} -->
                                    <!-- from: 关联对象表格查找关联字段存在未落哭数据，前端自行拼接，from为30时候，查找关联字段字段的watch不进行触发 -->
                                    <template v-if="modulesItem.value === 'opportunityStage'">
                                      <xl-update-fields :modules="stageModulesItem(modulesItem)" :disabled-all="data.disabledAll" :formatData="data.form.formData" @cb="updateModulesItem" :errorDataMap="errorDataMap" />
                                    </template>
                                    <template v-else>
                                      <xl-update-fields :modules="modulesItem" :type="data.type" :disabled-all="data.disabledAll" :formatData="data.form.formData" @cb="updateModulesItem" :errorDataMap="errorDataMap" />
                                    </template>
                                  </template>
                                  <!--附加说明 -->
                                  <div class="tips-detail" v-if="modulesItem?.memo">
                                    {{ modulesItem?.memo }}
                                  </div>
                                </jw-form-item>
                              </template>

                              <!-- 对象表格 (30)-->
                              <template v-else-if="modulesItem.type == '30'">
                                <ly-form-table v-if="!isAssociated" :ref="($event) => setRef($event, modulesItem?.id)" :type="data.type" :copy="data.copy" :viewId="data.viewId" :entity="data.entity" :id="data.id" :formData="data.form.formData" :detail-list="detailList?.[modulesItem?.id] ?? []" @cb="getRecord" :modules="modulesItem" :btns="isEditableField([modulesItem?.value, modulesItem?.id], ruleFields.value, data.permissionBak?.[modulesItem.value]?.businessData ?? 1) && !data.disabledAll ? tableModuleBtnList?.[modulesItem?.id] ?? [] : []" />
                              </template>
                              <!-- 子表单 (35)-->
                              <template v-else-if="modulesItem.type == '35'">
                                <ly-subform-table
                                  :ref="($event) => setRef($event, modulesItem?.id)"
                                  :type="data.type"
                                  :copy="data.copy"
                                  :viewId="data.viewId"
                                  :entity="data.entity"
                                  :id="data.id"
                                  :isAssociated="isAssociated"
                                  :modules="{
                                    ...modulesItem,
                                    modules: modulesItem?.modules?.filter((mm) => isShowField(`${modulesItem.value}.${mm.value}`, ruleFields.value, data.permissionBak?.[`${modulesItem.value}.${mm.value}`]?.display ?? 1))
                                  }"
                                  :allModules="modulesItem"
                                  :isCanEdit="isEditableField([modulesItem.value, modulesItem?.id], ruleFields.value, data.permissionBak?.[modulesItem.value]?.businessData ?? 1) && !data.disabledAll"
                                  :from="20"
                                  :mainForm="data.form.formData"
                                />
                              </template>
                            </jw-col>
                          </template>
                        </template>
                      </jw-card>
                    </template>
                  </jw-row>
                </jw-form>
              </template>
              <template v-if="!data.initStatus && !data.form.formData">
                <jw-empty :img-src="noDataSvg" :description="$t('暂无数据')" />
              </template>
            </jw-spin>
          </jw-card>
        </jw-space>
      </div>
    </jw-space>
  </div>
  <!-- 关联工商信息 -->
  <xl-business-information ref="informationRef" @cb="getselectCustomer"></xl-business-information>
  <!-- 展示关联的工商信息 -->
  <xl-business-message ref="businessmessageRef"></xl-business-message>
</template>

<script setup>
import { reactive, ref, provide, computed, watch, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { clientService, layoutService, setService, migrationToolsService } from '@/api/';
import useLoading from '@/hooks/loading';
import useViewFields from '@/hooks/view-fields';
import useFormulaSetting from '@/hooks/formulaSetting';
// import FhFormTable from '@/components/fh-form-tabel/fh-form-tabel.vue';
import { useI18n } from 'vue-i18n';
import { useUserStore, useGrayscaleStore } from '@/store';
import { Message } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import { useAssociationWatch } from '@/hooks/association-watch';
import { bingOrgId, huaYingOrdId } from '@/utils/const';
import dayjs from 'dayjs';
const emits = defineEmits(['cb', 'cbResult']);
const route = useRoute();
const { t } = useI18n();
import _ from 'lodash';
const { loading, setLoading } = useLoading(false); //loading
const { rules, getAddLayoutConfig, saveFormData, sendFormData, layoutAddModules, getEditLayoutConfig, layoutDetailModules } = useViewFields();
const { findComputeing, findCountFieldsList } = useFormulaSetting();
import fieldPermission from '@/hooks/field-permission';
import { useEnvConfig } from '@/hooks/env-config';
const { isShowField, isEditableField, initPermissionBak } = fieldPermission();
import fieldDefaultVal from '@/hooks/default-value'; //默认值相关的hooks
const { getDefValFields, getNewDefVal, updateSubFormKeys } = fieldDefaultVal();
const editAddForm = ref(); //form表单
const { userInfo } = useUserStore(); //用户信息
const { grayList } = useGrayscaleStore();
const informationRef = ref(); //客户--关联工商信息
const businessmessageRef = ref(); //客户--展示工商信息
const detailList = ref({}); //关联表格的数据
const tableModuleBtnList = ref({}); //关联表格按钮集合
const detailModuleList = ref({}); //关联表格数据信息
const checkName = ref(); //公司名称/客户名称/商机名称校验重复
const showApproveBtn = ref(); // 是否发起审批按钮
const statusOrigin = ref(); //该条数据的生命状态
const props = defineProps({
  // 数据ID
  id: { type: String },
  type: { required: true },
  viewId: { required: true },
  entity: { required: true },
  copy: { required: true },
  getEntityObj: { required: true },
  //2025年02月27日16:45:55 是否是关联对象表格，是的话过滤关联对象表格并且添加不走接口直接将数据组装后返回并关闭弹窗
  isAssociated: {
    type: Boolean,
    default: false
  },
  //是否从copy过来的，兼容关联对象表格复制，为落库情况下，编辑和复制所有参数一致，单独添加复制标识
  fromCopy: {
    type: Boolean,
    default: false
  },
  //关联对象表格的key 当isAssociated值为true时使用
  associateKey: {
    type: String,
    default: ''
  },
  //兼容编辑关联对象表格数据没有id的情况，直接使用数据
  editRecord: {
    type: Array,
    default: () => {
      return [];
    }
  },
  followObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  scheduleObj: {
    type: Object,
    default: () => {
      return {};
    }
  }
});

console.log(197, props);
const isShowGroupName = (group) => {
  return !props.isAssociated || group?.filter((g) => g?.type != 30)?.length > 0;
};
// 关联对象表格数据信息
const getRecord = (cf) => {
  detailModuleList.value[cf?.id] = cf.modules;
};
const callbackSubFormData = (callbackData) => {
  detailModuleList.value[callbackData?.id] = callbackData.modules;
};

// 子表单更新数据
const providedMethods = {
  setCallbackData: callbackSubFormData
};

provide('methods', providedMethods);
const submitType = ref();
const data = reactive({
  //公共的变量
  followObj: props.followObj,
  orgId: userInfo?.orgId, //组织id
  //2025年06月27日16:14:49 zl删除从route获取id 因为路由已经不存在，兼容复制移动端新建路由跳转
  id: props.id,
  // id: props.id || route.params?.id,
  type: props.type || route.params?.type, //30: 新增 40：修改
  viewId: props.viewId || route.params?.viewId, //视图id
  entity: props.entity || route.params?.entity, //对象type
  copy: props.copy || route.params?.copy, //复制
  fromPage: route.params?.fromPage, //其他入口新增客户
  getEntityObj: props?.getEntityObj || {}, //从其他对象详情关联对象表格新增
  loadingTips: '',
  tableLoading: false,
  initStatus: true, //初始化标识
  saveStatus: false, //保存标识
  fieldListModules: [],
  fieldList: [],
  form: {
    formData: []
  },

  productList: [],
  buttonsObj: {},
  operationObj: {
    //操作按钮权限标识
    101: 'cluePool', //线索池
    1: 'clue', //线索
    2: 'customer', //客户
    3: 'businessOpportunity', //商机
    4: 'product', //产品
    6: 'priceSheet', //报价单
    8: 'contract', //合同
    10: 'saleOrder', //销售订单
    12: 'afterSale', //售后服务
    13: 'returnOrder', //退货单
    16: 'dynamicRecord' //动态记录
  },
  //客户有关变量
  qccId: '',
  qccInfo: null, //当前工商信息
  //商机有关变量
  captainList: [], //车队长下拉列表
  splitSave: false, //订单是否按照明细拆分提交true/false
  displayOneLineFields: [18, 26], //整行显示的字段
  disabledAll: true,
  isDoneFirst: false,
  permissionBak: {},
  defValields: [],
  valIsComplete: true, //默认值是否完成
  submitIsComplete: false //是否点击确定
});
provide('globalFormData', {
  isDoneFirst: computed(() => data.isDoneFirst)
});
// 商机有关的变量
const nameList = ref({
  customerName: null,
  fundName: null
});

// 计算错误映射
const errorDataMap = ref();
const ruleFields = ref({});
// 此处是处理商机阶段在新建/复制时默认选择第一个
const stageModulesItem = (item) => {
  if (item.value === 'opportunityStage' && (data.type == 30 || data.copy == 1)) {
    // 两种方案：：：：(产品确认使用2)
    // 1.如果是复制或者新增，赋值默认值
    // newObj.fieldValue = newObj.defaultValue;
    // 2.如果是复制或者新增，永远赋值第一个阶段
    const ext = item.setting.fieldExt;
    const parseExt = tools.isJSON(ext) && JSON.parse(ext) && JSON.parse(ext)?.length && JSON.parse(ext)?.[0]?.value;
    item.fieldValue = parseExt;
  }
  return item;
};

//判断是否命中审批
const isHitApproval = async () => {
  const json = await setService.isHitApproval({
    entity: data.entity,
    businessId: data.id
  });
  if (json && !json?.error) {
    showApproveBtn.value = json.result?.openApprove || false;
    statusOrigin.value = data.type == 30 ? null : json.result?.statusOrigin;
  }
};
const { fieldMappings, config } = useEnvConfig(data.entity);

// ------公共部分------
// 获取视图ID
const getViewId = async (views) => {
  data.viewId = views?.viewId; //视图id
  setLoading(true);
  data.loadingTips = t('数据加载中') + '……';
  data.form.formData = [];
  data.initStatus = true;
  data.valIsComplete = true; //默认值是否完成
  data.submitIsComplete = false; //是否点击确定
  init();
  /************* 新建编辑流程调整 以下接口使用异步请求 start **************/
  //异步获取对象名字用于展示
  getObjectName();
  if (!props.isAssociated) isHitApproval();
  /************* 新建编辑流程调整 以下接口使用异步请求 end **************/
};
//提交
const submit = (handleType) => {
  data.splitSave = false;
  submitType.value = handleType;
  editAddForm?.value?.handleSubmit();
};
// 订单明细拆分
const splitOrderSubmit = () => {
  data.splitSave = true;
  editAddForm?.value?.handleSubmit();
};
const refs = reactive({});
const setRef = (e, id) => {
  refs[`formTable${id}`] = e;
};
// 合同/订单中切换报价单
const priceChange = (entity) => {
  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 30 && item?.modules) {
          //组件表格
          refs?.[`formTable${item?.id}`]?.setDetailProduct(entity); //需要把有关带出的明细清除
        }
      });
    }
  });
};
//订单中切换合同
const contractChange = (entity) => {
  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 30 && item?.modules) {
          //组件表格
          refs[`formTable${item?.id}`]?.setDetailProduct(entity); //需要把有关带出的明细清除
        }
      });
    }
  });
};
// 获取关联表格按钮集合
const getBtns = (formData) => {
  formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 30 && item?.modules) {
          //组件表格
          tableModuleBtnList.value[item.id] = item?.modules?.filter((v) => v.type == 40) || [];
        }
      });
    }
  });
};
//获取对象名称
const objectName = ref('');
const getObjectName = async () => {
  try {
    const res = await setService.getSysObjEnumList({ entityType: data.entity });
    if (!res.error) {
      objectName.value = res.result?.entityName;
    }
  } catch (e) {
    console.log(e);
  }
};
const getTitle = computed(() => {
  let _title = '';
  if (data.type == 40) {
    _title = t('编辑');
  } else {
    if (data.copy == 1 || props.fromCopy) {
      _title = t('复制');
    } else {
      if (props.editRecord?.length) {
        _title = t('编辑');
      } else {
        _title = t('新建');
      }
    }
  }
  if (objectName.value) {
    _title += `-${objectName.value}`;
  }

  return _title;
});
// 获取默认值参与条件的字段
const getDefValFieldList = async () => {
  try {
    const defValields = await getDefValFields({ entity: data.entity });
    if (!defValields.error) {
      data.defValields = defValields?.result || [];
    }
  } catch (e) {
    console.log(e);
  }
};

// 初始化
const init = async () => {
  if (data.type == 30) {
    //获取新增的布局
    if (data.copy == 1) {
      //复制
      await Promise.all([
        getEditLayoutConfig({ viewId: data.viewId, businessId: data.id, entity: data.entity, copy: true }),
        findComputeing(data.entity, data.viewId, data.type) //获取页面中的计算字段
      ]);
      const _formData = layoutDetailModules?.value[0]?.modules?.filter((item) => item?.type != 40) || [];
      /*********** 关联表格过滤关联主键 start ************/
      if (props.isAssociated && props.associateKey) {
        _formData.forEach((_fd) => {
          if (_fd?.modules?.length) {
            _fd.modules = _fd?.modules?.filter((_fdm) => _fdm?.setting?.fieldKey != props.associateKey);
          }
        });
      }
      /*********** 关联表格过滤关联主键 end ************/
      data.form.formData = _formData;
      data.buttonsObj = tools.getUpdateOptTextsByEntity(layoutDetailModules?.value[0]?.modules?.filter((item) => item?.type == 40) || []);
    } else {
      //新建
      await Promise.all([
        getAddLayoutConfig({ viewId: data.viewId, entity: data.entity }),
        findComputeing(data.entity, data.viewId, data.type) //获取页面中的计算字段
      ]);
      const _formData = layoutAddModules?.value[0]?.modules?.filter((item) => item?.type != 40) || [];
      /******** 处理关联对象表格新建编辑子表单 start ********/
      //是关联对象表格过来的，并且没有id，并且编辑数据不为空，则将子表单数据同步到表格中
      if (props.isAssociated && !data.id && props.editRecord?.length) {
        _formData?.forEach((list) => {
          if (list?.modules) {
            list?.modules.forEach((item) => {
              if (item.type == 35 && item?.modules?.length) {
                const _find = props.editRecord?.find((v) => v?.setting?.fieldKey === item?.setting?.fieldKey);
                if (_find && Object.keys(_find)?.length) {
                  const _formatSubFormData = [];
                  _find?.modules?.map((fm) => {
                    const _child = {};
                    fm?.map((fmm) => {
                      _child[fmm?.value] = fmm?.fieldValue;
                    });
                    _formatSubFormData.push(_child);
                  });
                  item.fieldValue = {
                    records: _formatSubFormData
                  };
                  detailList.value[_find?.id] = _formatSubFormData || [];
                  console.log(_formatSubFormData, 'console.log(_formatSubFormData');
                }
              }
            });
          }
        });
      }
      /******** 处理关联对象表格新建编辑子表单 end ********/
      /*********** 关联表格过滤关联主键 start ************/
      if (props.isAssociated && props.associateKey) {
        _formData.forEach((_fd) => {
          if (_fd?.modules?.length) {
            _fd.modules = _fd?.modules?.filter((_fdm) => _fdm?.setting?.fieldKey != props.associateKey);
          }
        });
      }
      /*********** 关联表格过滤关联主键 end ************/
      data.form.formData = _formData;
      data.buttonsObj = tools.getUpdateOptTextsByEntity(layoutAddModules?.value[0]?.modules?.filter((item) => item?.type == 40) || []);
      if (data.entity == 3) {
        //商机的特殊处理
        data.form.formData?.map(async (dfc) => {
          dfc?.modules?.map(async (dfcm) => {
            if (dfcm.value == 'opportunityStage') {
              const _fieldExt = JSON.parse(dfcm.setting.fieldExt);
              dfcm.fieldValue = _fieldExt[0].value;
            }
          });
        });
      }
      if (data.followObj?.isSourceDetailStatus) setFollowValue();
    }
  }
  if (data.type == 40) {
    //获取编辑的布局
    await Promise.all([
      getEditLayoutConfig({ viewId: data.viewId, businessId: data.id, entity: data.entity }),
      findComputeing(data.entity, data.viewId, data.type) //获取页面中的计算字段
    ]);
    const _formData = layoutDetailModules?.value[0]?.modules?.filter((item) => item?.type != 40) || [];
    /*********** 关联表格过滤关联主键 start ************/
    if (props.isAssociated && props.associateKey) {
      _formData.forEach((_fd) => {
        if (_fd?.modules?.length) {
          _fd.modules = _fd?.modules?.filter((_fdm) => _fdm?.setting?.fieldKey != props.associateKey);
        }
      });
    }
    /*********** 关联表格过滤关联主键 end ************/
    data.form.formData = _formData;
    data.buttonsObj = tools.getUpdateOptTextsByEntity(layoutDetailModules?.value[0]?.modules?.filter((item) => item?.type == 40) || []);
    if (data.followObj?.isSourceDetailStatus) setFollowValue();
  }
  getBtns(_.cloneDeep(data.form.formData));
  setLoading(false);
  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if ((item.type == 30 || item.type == 35) && item?.modules) {
          if (item.type == 30) {
            //组件表格
            item?.modules.forEach((el) => {
              // 参与计算的字段给标识
              if (findCountFieldsList.value?.[Number(item.businessData)] && findCountFieldsList.value[Number(item.businessData)]?.indexOf(el.setting?.fieldKey) != -1) {
                el.setting.idCalculationsFields = true;
              }
            });
          }
          if (data.type == 40 || data.copy == 1) {
            //编辑
            detailList.value[item.id] = item?.fieldValue?.records || [];
          }
        }
        if (item.type == 20) {
          /******** 处理关联对象表格新建编辑 start ********/
          //同上子表单 将普通字段数据放到表格中
          if (props.editRecord?.length) {
            const _find = props.editRecord?.find((v) => v?.setting?.fieldKey === item?.setting?.fieldKey);
            if (_find && Object.keys(_find)?.length) {
              item.fieldValue = _find.fieldValue;

              item.setting = _.cloneDeep(_find.setting);
              if ([12, 25].includes(item.setting.fieldType)) {
                item.customValue = _.cloneDeep(_find.customValue);
              }
            }
          }

          //产品--税率字段(因为fieldType==4 需要特殊处理label: "0.06"处理成'6%')
          if (data.entity == 4 && item?.setting?.fieldKey === 'taxRate' && item?.setting?.fieldType == 4 && tools.isJSON(item.setting?.fieldExt)) {
            const fe = JSON.parse(item.setting?.fieldExt)?.map((v) => ({
              ...v,
              label: tools.getPercentage(v.label, 0) + '%'
            }));
            item.setting.fieldExt = JSON.stringify(fe);
          }
          // 参与计算的字段给标识
          if (findCountFieldsList.value?.[Number(data.entity)] && findCountFieldsList.value?.[Number(data.entity)]?.indexOf(item.setting?.fieldKey) != -1) {
            item.setting.idCalculationsFields = true;
          }
        }
      });
    }
  });

  const permissionBak = initPermissionBak(data.form.formData, data.type);
  data.permissionBak = permissionBak;
  const op = {
    viewId: data.viewId,
    entity: data.entity,
    formData: data.form.formData,
    detailList: detailModuleList.value,
    type: data.type,
    id: data.id || null,
    from: 1,
    permissionBak,
    init: true
  };
  if (data.type == 30) {
    //新建
    getDefValFieldList(); //获取参与默认值规则的条件
    if (!props.editRecord?.length && data.copy != 1) {
      await getNewDefVal(op, 1);
    }
  }

  data.form.formData?.forEach((list) => {
    if (list?.modules) {
      list?.modules.forEach((item) => {
        if (item.type == 20) {
          //客户--关联工商信息
          if (item?.setting.fieldKey == 'qccId') {
            data.qccId = item.fieldValue;
          }
          if (data.type == 30 && data.copy !== 1) {
            //新增的时候处理（从其他对象详情关联对象表格新增）
            if (data.getEntityObj && Object.keys(data.getEntityObj)?.length > 0) {
              if (item?.setting.fieldType == 12 && item?.setting.fieldExt == data.getEntityObj.fieldExt) {
                //查找关联单选
                item.fieldValueName = data.getEntityObj.label;
                item.fieldValue = data.getEntityObj.value;
              }
            }
          }
        }
        if (data.type == 30 && data.copy != 1 && !props.editRecord?.length) {
          //新增---子表单
          const getSubFormKeys = Object.keys(updateSubFormKeys.value);
          if (getSubFormKeys?.length > 0) {
            if (item.type == 35 && item?.modules?.length && getSubFormKeys.includes(item.setting.fieldKey)) {
              const getRecord = updateSubFormKeys.value[item.setting.fieldKey];
              refs?.[`formTable${item?.id}`]?.updateRecord(getRecord);
            }
          }
        }
      });
    }
  });

  const { errorDataMap, fieldPermission, isDisabledAll, isDoneFirst } = useAssociationWatch(data.form.formData, data.entity, op, data.copy === 1);
  data.disabledAll = isDisabledAll;
  data.isDoneFirst = isDoneFirst;
  errorDataMap.value = errorDataMap;
  ruleFields.value = fieldPermission;
  setLoading(false);
  if (data.form.formData?.length == 0 || !data.form.formData) {
    data.initStatus = false;
  }
};
// 更新子表单数据
const updateSubRecord = () => {
  const getSubFormKeys = Object.keys(updateSubFormKeys.value);
  if (getSubFormKeys?.length > 0) {
    data.form.formData?.forEach((item) => {
      item.modules?.forEach((list) => {
        if (list.type == 35 && list?.modules?.length && getSubFormKeys.includes(list.setting.fieldKey)) {
          const getRecord = updateSubFormKeys.value[list.setting.fieldKey];
          refs?.[`formTable${list?.id}`]?.updateRecord(getRecord);
        }
      });
    });
  }
};
//子组件回调
const updateModulesItem = async (getformatData, modulesItem) => {
  if (getformatData && getformatData?.value) {
    data.form.formData = getformatData.value;
  }
  if (data.entity == 3 && modulesItem?.setting?.fieldKey == 'customerId') {
    //商机特殊处理
    nameList.value.customerName = modulesItem?.customValue?.label;
    hyFormatName();
    if (userInfo?.orgId === 3) {
      //商机名称 只针对租户3生效
      data.form.formData?.forEach((item) => {
        if (item?.modules) {
          item?.modules?.forEach(async (list) => {
            if (list.type == 20) {
              if (list?.setting.fieldKey === 'opportunityName' && nameList.value.customerName) {
                list.fieldValue = nameList.value.customerName + ' ' + dayjs(new Date()).format('YYYY-MM-DD');
              }
            }
          });
        }
      });
    }

    if (userInfo?.orgId === bingOrgId) {
      // 调用接口
      await getCustomer(modulesItem?.customValue?.value);
    }
  }
  if ([6, 22, 12, 18, 25].includes(parseInt(modulesItem?.setting?.fieldType))) {
    //人员或部门或查找单选多选
    data.form.formData?.forEach((item, parentIndex) => {
      if (item?.modules) {
        item?.modules?.forEach((list, index) => {
          if (list.type == 20) {
            if (list.value == modulesItem.value) {
              editAddForm.value?.clearValidate([`formData.${parentIndex}.modules.${index}.fieldValue`]);
            }
          }
        });
      }
    });
  }
  if (data.defValields?.includes(modulesItem?.setting?.fieldKey)) {
    data.valIsComplete = false;
    //触发了默认值规则
    const getParames = {
      entity: data.entity,
      formData: data.form.formData,
      changeFieldKey: modulesItem?.setting?.fieldKey,
      init: false
    };
    if (props?.fromCopy || data.copy == 1 || (data.type == 30 && !props.editRecord?.length)) {
      //新建和复制数据时触发默认值规则
      try {
        await getNewDefVal(getParames, 1);
        updateSubRecord(); //更新子表单
      } catch (error) {
        console.error('获取新默认值时出错:', error);
      } finally {
        data.valIsComplete = true;
      }
    }
  }
};
const stopWatch = watch(
  () => data.valIsComplete,
  () => {
    if (data.valIsComplete && data.submitIsComplete) {
      //默认值已完成
      //点击了【确定】按钮
      submitFormData();
    }
  },
  { deep: true }
);
onBeforeUnmount(() => {
  stopWatch();
});
const handleLoading = () => {
  setLoading(true);
  data.saveStatus = true;
  data.initStatus = true;
  data.loadingTips = t('数据保存中') + '……';
};
const labelWidth = (callbackData) => {
  let width = '131px'; //1/2
  if (callbackData.displayOneLine == 2) {
    //2是1/3
    width = '156px';
  } else if (callbackData.displayOneLine == 3) {
    //3是2/3行展示
    width = '122px';
  } else if (callbackData.displayOneLine == 1) {
    //整行
    width = '114px';
  }
  if (data.displayOneLineFields.includes(callbackData?.setting?.fieldType)) {
    //附件,富文本
    width = '114px';
  }
  return width;
};
// 必填校验和数量限制校验
const validateFormItems = () => {
  const inputList = [0, 1, 7, 11, 13, 16, 23, 26]; // 请输入的字段
  // 遍历表单数据
  const getFormData = data.form.formData;
  for (const formItem of getFormData || []) {
    if (!formItem?.modules) continue;

    // 遍历模块
    for (const module of formItem.modules) {
      // 必填校验
      const isRequired = ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1) && (module.conditionsIsRequired === 1 || module.isRequired === 1);
      //富文本必填校验
      if (module?.type == 20 && module?.setting?.fieldType == 26 && isRequired && (module?.fieldValue == '<p><br></p>' || module?.fieldValue == '')) {
        Message.warning(t('请输入') + module?.setting?.fieldName);
        return {
          hasEmptyRequiredTable: true,
          hasOverTable: false,
          hasSubFormEmptyError: false,
          hasLinkError: false
        };
      }
      if (module?.type == 30 || module?.type == 35) {
        const data = detailModuleList.value?.[module.id];
        if (isRequired && (!data || data.length === 0)) {
          const requiredErrorMessage = module?.label ? `请至少添加一条【${module?.label}】数据！` : module.type === 35 ? '请至少添加一条子表单数据' : '请至少添加一条明细数据！';
          Message.warning(requiredErrorMessage);
          return {
            hasEmptyRequiredTable: true,
            hasOverTable: false,
            hasSubFormEmptyError: false,
            hasLinkError: false
          };
        }

        // 数量限制校验
        if (module.type == 35 && data && data.length > 300) {
          Message.warning('子表单数据最多添加300行！');
          return {
            hasEmptyRequiredTable: false,
            hasOverTable: true,
            hasSubFormEmptyError: false,
            hasLinkError: false
          };
        }

        //只有子表单走此逻辑 关联对象表格的必填校验在弹窗点击确定的时候校验
        if (module?.type == 35) {
          // 校验子表单超链接格式(二维数组)
          for (const list of data || []) {
            for (const item of list || []) {
              if (item?.setting?.isRequired && (item.fieldValue === '' || item.fieldValue === null || item.fieldValue === undefined || (Array.isArray(item.fieldValue) && item.fieldValue?.length === 0))) {
                const waringMsg = inputList.includes(item?.setting?.fieldType) ? '请输入' + item?.setting?.fieldName : '请选择' + item?.setting?.fieldName;
                Message.warning(waringMsg);
                return {
                  hasEmptyRequiredTable: false,
                  hasOverTable: false,
                  hasSubFormEmptyError: true,
                  hasLinkError: false
                };
              }

              if (item?.setting?.fieldType === 11 && item?.fieldValue && !tools.checkLink(item.fieldValue)) {
                const linkErrorMessage = '格式不正确，请以http:// 或 https:// 开头，且不能包含汉字!';
                Message.warning(linkErrorMessage);
                return {
                  hasEmptyRequiredTable: false,
                  hasOverTable: false,
                  hasSubFormEmptyError: false,
                  hasLinkError: true
                };
              }
            }
          }
        }
      }
    }
  }

  // 如果所有检查都通过，返回没有错误的结果
  return {
    hasEmptyRequiredTable: false,
    hasOverTable: false,
    hasSubFormEmptyError: false,
    hasLinkError: false
  };
};
// 所有字段或者分组隐藏了需要把分组标题隐藏掉
const validateConditionsDisplay = (moduleItem) => {
  const isDisplayField = [];
  moduleItem.modules?.forEach((module) => {
    if (module.type == 20) {
      //字段
      if ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1) {
        isDisplayField.push(module);
      }
    }
    if ((module.type == 30 || module.type == 35) && module.modules?.length > 0) {
      //表格或者子表单
      if ((module.display === 2 && module.conditionsDisplay === 1) || module.display === 1) {
        isDisplayField.push(module);
      }
    }
  });
  return isDisplayField;
};
// 提交
const handleSubmit = async ({ values, errors }) => {
  console.log('handleSubmit', errors, values);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    const errorMsg = Object.values(errors)?.[0]?.message;
    if (errorMsg) Message.error(errorMsg);
    editAddForm?.value.setFields(errorArray);
    setLoading(false);
    return;
  }
  //这里是获取modules里的字段信息用于以下特殊处理
  //关联工商信息
  const getQccId = data.form.formData?.flatMap((item) => item?.modules).find((v) => v?.setting?.fieldKey === 'qccId');
  //合同
  // const saleContract = data.form.formData?.flatMap((item) => item?.modules).find((v) => v?.setting?.fieldKey === 'contractId');
  //凭证截图
  // const saleVoucher = data.form.formData?.flatMap((item) => item?.modules).find((v) => v?.setting?.fieldKey === 'proof_screen_shoot');
  //订单类型
  // const saleOrderType = data.form.formData?.flatMap((item) => item?.modules).find((v) => v?.setting?.fieldKey === 'saleOrderType');

  //客户--对工商关联信息校验
  if (data.entity == 2) {
    // if (getQccId && !data.qccId && ((getQccId?.conditionsDisplay == 1 || getQccId.display != 2) && (getQccId?.conditionsIsRequired == 1) || getQccId?.isRequired == 1)) {
    //   //没有关联工商信息
    //   return false;
    // }
    if (getQccId && !data.qccId) {
      // 设置了条件显示
      if (((getQccId?.display == 2 && getQccId?.conditionsDisplay == 1) || getQccId?.display == 1) && (getQccId?.conditionsIsRequired == 1 || getQccId?.isRequired == 1)) {
        //没有关联工商信息
        return false;
      }
    }
  }
  //文件未上传完给提示
  const incompleteFileList = [];
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules?.forEach((list) => {
        if (list.type == 20 && list?.setting?.fieldType === 18) {
          if (list.fieldValue && list.filesList && list.fieldValue.length != list.filesList.length) {
            incompleteFileList.push(list.fieldValue);
          }
        }
      });
    }
  });

  if (incompleteFileList && incompleteFileList.length) {
    Message.warning(t('文件未上传完成,请稍后提交！'));
    return;
  }
  //对币种校验
  if (detailModuleList.value && Object.keys(detailModuleList.value).length > 0) {
    const currencyType = [];
    for (const key in detailModuleList.value) {
      detailModuleList.value[key]?.map((list) => {
        list?.map((item) => {
          if (item?.setting?.fieldKey == 'currency' || item?.setting?.fieldKey == 'currencyType') {
            // 只能选择一种币种(商机产品的币种是：currency，其他对象产品的是：currencyType)
            currencyType.push(item.fieldValue);
          }
        });
      });
    }

    const formatArr = Array.from(new Set(currencyType));
    if (formatArr?.length > 1) {
      //有重复数据
      Message.error(t('tips.moreCurrency'));
      return;
    }
  }
  // 调用验证函数
  const validationResult = validateFormItems();

  if (validationResult.hasEmptyRequiredTable || validationResult.hasOverTable || validationResult.hasSubFormEmptyError || validationResult.hasLinkError) {
    // 如果有必填项未填写或超过数量限制，则不再继续后续操作
    return;
  }

  /******************** 迁移工具 start ***********************/
  // TAG: 迁移工具
  if (userInfo?.orgId == config.migrationOrgId && data.entity == config.migrationToolsEntity) {
    const result = await checkFormData();
    if (!result) {
      return;
    }
  }
  if (!data.valIsComplete) {
    //默认值是否完成
    data.submitIsComplete = true;
    handleLoading();
    return;
  }

  /******************** 迁移工具 end ***********************/

  submitFormData(); //新增/编辑
};
/** 迁移工具表单校验 */
const checkFormData = async () => {
  const formData = data.form.formData
    ?.flatMap((item) => item.modules)
    ?.reduce((obj, item) => {
      obj[item.value] = item.fieldValue;
      return obj;
    }, {});
  try {
    const json = await migrationToolsService.validateTenantAndUser({
      tenantId: formData[fieldMappings.tenantId],
      userId: formData[fieldMappings.userId],
      appId: formData[fieldMappings.appId],
      appSecret: formData[fieldMappings.appSecret],
      sessionId: formData[fieldMappings.sessionId]
    });
    if (json.result?.result) {
      return true;
    } else {
      Message.error(json.result?.msg || t('数据获取失败'));
      return false;
    }
  } catch (e) {
    return false;
  }
};
const formatModalData = () => {
  const _formatModalData = [];
  data.form.formData?.map((fd) => {
    if (fd?.modules?.length) {
      fd?.modules?.map((fdm) => {
        if (fdm?.type == 20) {
          _formatModalData.push({
            ..._.cloneDeep(fdm),
            detailId: !props.copy && props.id ? props.id : undefined
          });
        }
        if (fdm?.type == 35) {
          _formatModalData.push({
            ...fdm,
            detailId: !props.copy && props.id ? props.id : undefined,
            modules: detailModuleList.value?.[fdm?.id] ? _.cloneDeep(detailModuleList.value?.[fdm?.id]) : []
          });
        }
      });
    }
  });
  emits('cbResult', _formatModalData);
};
const submitFormData = async () => {
  if (props.isAssociated) {
    //如果是关联对象表格过来的直接emits cb，不进行表单提交
    formatModalData();
    return false;
  }
  if (!data.saveStatus) handleLoading(); //没有loading

  await saveFormData(data.viewId, data.entity, data.form.formData, detailModuleList.value, data.type, 'addOrEdit');
  let url;
  if (submitType.value == 'approve') {
    //发起审批
    sendFormData.value.approve = true;
  } else {
    sendFormData.value.approve = false;
    sendFormData.value.afterApprove = true;
  }

  if (data.type == 30) {
    //新增
    if (data.entity == 10) {
      //订单拆分明细提交
      sendFormData.value.isNeedSplit = data.splitSave ? true : false;
    }
    // 日程添加动态记录特殊参数
    if (sendFormData.value?.entity == 16 && JSON.stringify(props.scheduleObj) !== '{}') {
      sendFormData.value.data = {
        ...sendFormData.value.data,
        ...props.scheduleObj
      };
    }
    console.log('新增表单信息', sendFormData.value);
    url = layoutService.add(sendFormData.value);
  }

  if (data.type == 40) {
    //编辑
    url = layoutService.update(sendFormData.value);
  }

  try {
    const res = await url;
    setLoading(false);
    if (res.error && res.error?.msg) {
      Message.error(res.error?.msg || t('获取数据失败'));
      return;
    }
    Message.success(t('提交成功'));
    editAddForm.value.resetFields(); //添加成功后清空抽屉表单元素
    data.form.formData = [];
    emits('cb', 'submit');
    emits('cbResult', res.result);
    return;
  } catch (e) {
    setLoading(false);
  }
};
// ------公共部分结束------

// ------对数据的特殊处理------

// 是否隐藏 关数据来源与 来源数据名称
const getFollowIsHide = (modulesItem) => {
  if ((modulesItem.value === 'entityType' || modulesItem.value === 'businessId') && data.followObj.isSourceDetailStatus) {
    return false;
  } else {
    return true;
  }
};
// 其他对象 新建 动态记录  设置默认值
const setFollowValue = () => {
  data.form.formData?.forEach((list) => {
    if (list?.modules?.length) {
      list.modules.forEach((item) => {
        if (item?.setting?.fieldKey == 'entityType') {
          item.fieldValue = data.followObj.sourceEntity.toString();
        }
        if (item?.setting?.fieldKey == 'businessId') {
          item.fieldValue = data.followObj.sourceId.toString();
        }
        if (item?.setting?.fieldKey == 'followStartTime') {
          if (item.isExistDefValue == 0 && props.scheduleObj.followStartTime) {
            item.fieldValue = props.scheduleObj.followStartTime;
          }
        }
      });
    }
  });
};

//------线索、线索池特殊处理-------
// 校验公司名称是否重复
const companyInput = async (modulesItem) => {
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'companyName', data.type);
};
// ------客户特殊处理-------
const mobileRules = (basic) => {
  if (basic.isRequired == 1 || basic?.conditionsIsRequired == 1) {
    // 0-非必填 1-必填 2-满足条件必填
    return [
      {
        required: basic.isRequired,
        message: t('tips.phoneNumber')
      }
    ];
  }
};
//展示关联的工商信息
const busineShow = () => {
  if (data.qccId) {
    businessmessageRef.value?.messageShow(data.id, data.qccInfo);
  }
};
// 客户名称改变时删除天眼查工商信息
const customerInput = (modulesItem) => {
  data.qccId = '';
  data.qccInfo = null;
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'qccId') {
            list.fieldValue = ''; //工商id；
          }
        }
      });
    }
  });
  // 校验客户名称
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'customerName', data.type);
};
// 客户关联工商信息回调
const getselectCustomer = (qccItem) => {
  data.qccId = qccItem.id; //工商id；
  data.qccInfo = qccItem;
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'qccId') {
            list.fieldValue = qccItem.id; //工商id；
          }
          if (list?.setting.fieldKey === 'customerName') {
            list.fieldValue = qccItem.name; //工商信息名称
          }
        }
      });
    }
  });
};
// 点击--关联工商信息
const correlation = () => {
  data.form.formData?.forEach((item) => {
    if (item?.modules) {
      item?.modules.forEach((list) => {
        if (list.type == 20) {
          if (list?.setting.fieldKey == 'customerName') {
            if (list.fieldValue?.trim()) {
              informationRef.value.correlationOpen(list.fieldValue);
            } else {
              Message.warning('请输入客户名称');
            }
          }
        }
      });
    }
  });
};
// 对商机名称重复校验
const changeOpportunityName = async (modulesItem) => {
  if (modulesItem.fieldValue) checkName.value[0]?.companyInputc(modulesItem.fieldValue, modulesItem, 'opportunityName', data.type);
};
//车队长对商机名称特殊处理
const hyFormatName = () => {
  if (userInfo.orgId == huaYingOrdId) {
    data.form.formData?.map((dfc) => {
      dfc?.modules?.map((dfcm) => {
        if (dfcm.value == 'opportunityName' && nameList.value?.customerName && nameList.value?.fundName) {
          dfcm.fieldValue = `${nameList.value.customerName}-${nameList.value.fundName}`;
        }
      });
    });
  }
};
//车队长特殊处理
const fundChange = (v, e) => {
  nameList.value.fundName = e?.[0]?.label;
  hyFormatName();
};
// 根据客户ID获取该客户下数据
const getCustomer = async (id) => {
  try {
    const json = await clientService.getCustomer({ id });
    if (!json.error) {
      const res = json.result;
      const fieldKeyMapping = {
        input_eEF5aY: 'input_QH248P',
        cascade_AtrmjR: 'cascade_Ei8fCm',
        input_6ta7Ne: 'input_iAWnWZ',
        input_7h7GZQ: 'input_K3nsDW',
        input_6M4G3m: 'input_p36wB5',
        input_KQhDsa: 'input_4wshhc',
        input_jZsBhD: 'input_5DcwpM',
        select_single_GFCcEN: 'select_single_zJwG8e'
      };
      data.form.formData?.forEach((item, parentIndex) => {
        item.modules?.forEach((list, index) => {
          if (list.type === '20' && fieldKeyMapping[list.value]) {
            const fv = res?.find((v) => v.fieldKey === fieldKeyMapping[list.value])?.fieldValue;
            if (fv && fv !== '') {
              if (fieldKeyMapping[list.value] === 'cascade_Ei8fCm') {
                list.fieldValue = fv?.split('/');
              } else {
                list.fieldValue = fv;
              }
            } else {
              list.fieldValue = null;
            }
            if (list.fieldValue && list.fieldValue != '') {
              editAddForm.value?.clearValidate([`formData.${parentIndex}.modules.${index}.fieldValue`]);
            }
          }
        });
      });
    } else {
      Message.error(json.error?.msg || t('数据获取失败'));
    }
  } catch (e) {
    Message.error(e.message || e.statusText || t('数据获取失败'));
  }
};
</script>
<style scoped lang="less">
@import './ly-form.less';
</style>
